import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDtA0Iz-WgFeSf3Bi4LWj2DHPIHFBBjEkg",
    authDomain: "slack-clone-4ffe5.firebaseapp.com",
    databaseURL: "https://slack-clone-4ffe5.firebaseio.com",
    projectId: "slack-clone-4ffe5",
    storageBucket: "slack-clone-4ffe5.appspot.com",
    messagingSenderId: "1050512845282",
    appId: "1:1050512845282:web:d54dfa9f0e6a417c7171bb",
    measurementId: "G-WPP0VJ7SH3"
})

const db = firebaseApp.firestore();
const auth = firebase.auth()
const provider = new firebase.auth.GoogleAuthProvider();

export {auth,provider};
export default db;